/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ParagraphIcon = /*#__PURE__*/ createSvgIcon(
  'ParagraphIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.754 16a.734.734 0 01-.535-.216A.72.72 0 018 15.25V12c-1.111 0-2.056-.39-2.833-1.171C4.389 10.047 4 9.102 4 7.995s.39-2.05 1.17-2.828C5.95 4.389 6.893 4 8 4h6.25c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H13v9.744a.738.738 0 01-.214.537.714.714 0 01-.532.219.734.734 0 01-.535-.216.72.72 0 01-.219-.534V5.5h-2v9.744a.738.738 0 01-.214.537.714.714 0 01-.532.219z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ParagraphIcon;
